var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('img',{staticClass:"contactPhoto",attrs:{"src":"/images/nophoto.png"}}),_c('div',{staticClass:"contactNameDiv"})])}]

export { render, staticRenderFns }